import { AlertTriangle, Clock, TrendingDown, Smartphone } from "lucide-react";

interface ProblemSectionProps {
  isVisible: boolean;
}

const ProblemSection = ({ isVisible }: ProblemSectionProps) => {
  const problems = [
    {
      icon: Smartphone,
      title: "מודל כלכלי שבור",
      description: "אפליקציות דייטים מרוויחות מ'זמן מסך' — לא מ'זמן חופה'. האינטרס שלהן הוא להשאיר אתכם על המסך, לא לחבר אתכם.",
    },
    {
      icon: TrendingDown,
      title: "דופמין במקום התאמה",
      description: "כל Match! הוא 'זריקת דופמין' — תחושה טובה לרגע. אבל האלגוריתם מתעלם מהפרמטרים שמנבאים הצלחה לטווח ארוך.",
    },
    {
      icon: Clock,
      title: "בזבוז זמן מסיבי",
      description: "עשרות דייטים כושלים. שעות על סווייפים. כסף על מנויים. ובסוף? אותו מקום.",
    },
    {
      icon: AlertTriangle,
      title: "הימור על ההחלטה הכי חשובה",
      description: "זוגיות היא ההחלטה הכלכלית והרגשית החשובה ביותר בחיים. למה אנחנו ממשיכים להמר עליה?",
    },
  ];

  return (
    <section aria-labelledby="problem-heading" className="py-24 bg-navy-dark relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-500/20 to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-red-500/10 border border-red-500/30 rounded-full text-red-400 text-sm font-medium mb-6">
            הבעיה
          </span>
          <h2 id="problem-heading" className="text-3xl md:text-4xl font-bold mb-4 text-cream">
            למה <span className="text-red-400">אפליקציות הדייטים</span> נכשלות?
          </h2>
          <p className="text-cream/70 text-lg max-w-2xl mx-auto">
            המערכת בנויה נגדכם. הנה למה:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {problems.map((problem, index) => (
            <article
              key={problem.title}
              className={`p-6 rounded-2xl bg-navy/50 border border-red-500/20 backdrop-blur-sm transition-all duration-700 hover:border-red-500/40 ${
                isVisible 
                  ? "opacity-100 translate-y-0" 
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-red-500/10 flex items-center justify-center flex-shrink-0">
                  <problem.icon className="w-6 h-6 text-red-400" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-cream mb-2">{problem.title}</h3>
                  <p className="text-cream/70 leading-relaxed text-sm">{problem.description}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Transition statement */}
        <div className="text-center mt-16">
          <p className="text-xl md:text-2xl text-cream/90 font-medium">
            יש דרך אחרת. דרך <span className="text-gold">מדעית</span>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
